import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API, getAuthHeaders } from '../../utils/adminAuth';

export default function ShippingFeeSettings({ settings, onUpdate }) {
  const REGIONS = [
    { key: 'metro_manila', label: 'Metro Manila (NCR)' },
    { key: 'luzon', label: 'Luzon (Outside NCR)' },
    { key: 'visayas', label: 'Visayas' },
    { key: 'mindanao', label: 'Mindanao' },
  ];

  const fees = settings?.shipping_fees || { metro_manila: 100, luzon: 150, visayas: 200, mindanao: 250 };
  const freeThreshold = settings?.free_shipping_threshold || 0;
  const [localFees, setLocalFees] = useState(fees);
  const [localThreshold, setLocalThreshold] = useState(freeThreshold);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      const updated = { ...settings, shipping_fees: localFees, free_shipping_threshold: parseFloat(localThreshold) || 0, key: 'site_settings' };
      await axios.put(`${API}/admin/settings`, updated, { headers: getAuthHeaders() });
      onUpdate(updated);
      toast.success('Shipping fees updated');
    } catch { toast.error('Failed to update'); }
    setSaving(false);
  };

  return (
    <div className="bg-[#141414] border border-white/5 p-4 sm:p-6 space-y-4" data-testid="shipping-fee-settings">
      <div>
        <p className="text-white text-sm font-sans font-medium mb-1">Shipping Fees</p>
        <p className="text-white/40 text-xs font-sans">Set shipping rates per region (in PHP). These will be added at checkout.</p>
      </div>

      {REGIONS.map(r => (
        <div key={r.key} className="flex items-center justify-between gap-4">
          <label className="text-white/60 text-sm font-sans flex-1">{r.label}</label>
          <div className="flex items-center gap-1">
            <span className="text-white/30 text-sm">₱</span>
            <input
              type="number"
              value={localFees[r.key] ?? 0}
              onChange={e => setLocalFees(prev => ({ ...prev, [r.key]: parseFloat(e.target.value) || 0 }))}
              className="w-24 bg-transparent border-b border-white/20 text-white py-1 text-sm text-right focus:border-[#D4AF37] focus:outline-none"
              data-testid={`shipping-fee-${r.key}`}
            />
          </div>
        </div>
      ))}

      <div className="border-t border-white/10 pt-4 mt-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-white/60 text-sm font-sans">Free Shipping Threshold</p>
            <p className="text-white/30 text-xs font-sans">Orders above this amount get free shipping (0 = disabled)</p>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-white/30 text-sm">₱</span>
            <input
              type="number"
              value={localThreshold}
              onChange={e => setLocalThreshold(e.target.value)}
              className="w-24 bg-transparent border-b border-white/20 text-white py-1 text-sm text-right focus:border-[#D4AF37] focus:outline-none"
              data-testid="free-shipping-threshold"
            />
          </div>
        </div>
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="w-full bg-[#D4AF37] text-black py-2 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#F3E5AB] transition-colors disabled:opacity-50 mt-2"
        data-testid="save-shipping-btn"
      >
        {saving ? 'Saving...' : 'Save Shipping Fees'}
      </button>
    </div>
  );
}
